module.exports = __webpack_public_path__ + "static/media/how1.bd519aad.svg";